import UserLoginForm from '../../../components/forms/user_login/UserLoginForm'
import UserSignupForm from '../../../components/forms/user_signup/UserSignupForm'
import login_banner from '../../../assets/images/ChatGPT Image Aug 21, 2026, 02_58_31 PM.png'
import { Leaf, BarChart3, ShieldCheck } from 'lucide-react'
import Aos from 'aos'
import 'aos/dist/aos.css'

export const LoginImport = {
    login_banner,
    Leaf,
    BarChart3,
    ShieldCheck,
    UserLoginForm,
    UserSignupForm,
    Aos,
}